import { forwardRef, useEffect, useImperativeHandle, useRef } from "react";

// Reusable draw-to-sign canvas. ref exposes clear(), isEmpty(), toDataURL().
export const SignaturePad = forwardRef(function SignaturePad({ onInk, className = "", testid = "signature-canvas" }, ref) {
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const inked = useRef(false);

  useEffect(() => {
    const c = canvasRef.current;
    const ratio = window.devicePixelRatio || 1;
    c.width = c.offsetWidth * ratio; c.height = c.offsetHeight * ratio;
    const ctx = c.getContext("2d");
    ctx.scale(ratio, ratio); ctx.lineWidth = 2.4; ctx.lineCap = "round"; ctx.lineJoin = "round"; ctx.strokeStyle = "#0f172a";
  }, []);

  useImperativeHandle(ref, () => ({
    clear: () => { const c = canvasRef.current; c.getContext("2d").clearRect(0, 0, c.width, c.height); inked.current = false; onInk?.(false); },
    isEmpty: () => !inked.current,
    toDataURL: () => canvasRef.current.toDataURL("image/png"),
  }));

  const pos = (e) => { const r = canvasRef.current.getBoundingClientRect(); return [e.clientX - r.left, e.clientY - r.top]; };
  const down = (e) => { e.preventDefault(); canvasRef.current.setPointerCapture(e.pointerId); drawing.current = true; const ctx = canvasRef.current.getContext("2d"); const [x, y] = pos(e); ctx.beginPath(); ctx.moveTo(x, y); };
  const move = (e) => {
    if (!drawing.current) return;
    const ctx = canvasRef.current.getContext("2d"); const [x, y] = pos(e); ctx.lineTo(x, y); ctx.stroke();
    if (!inked.current) { inked.current = true; onInk?.(true); }
  };
  const up = () => { drawing.current = false; };

  return (
    <canvas ref={canvasRef} data-testid={testid} onPointerDown={down} onPointerMove={move} onPointerUp={up} onPointerLeave={up}
      className={`w-full h-40 rounded-xl border-2 border-dashed border-slate-300 bg-white touch-none cursor-crosshair ${className}`} />
  );
});
